function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1944(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 11.02,
    height: 1.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.3016666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 0.905
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.81,
    width: 11.02,
    height: 7.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 5.73
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.65,
    width: 11.02,
    height: 14.02,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 16.66
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 23.67,
    width: 11.02,
    height: 16.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5742857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 32.155
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.64,
    width: 11.02,
    height: 23.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2244444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 52.2
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 63.76,
    width: 11.02,
    height: 27.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 77.56
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.36,
    width: 11.02,
    height: 35.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2039999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 109.28
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 127.2,
    width: 11.02,
    height: 40.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 147.43
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 167.66,
    width: 11.02,
    height: 42.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 188.85
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 210.04,
    width: 11.02,
    height: 42.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2244444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 231.32
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 252.6,
    width: 11.02,
    height: 46.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 275.835
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 299.07,
    width: 11.02,
    height: 47.32,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 322.73
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 346.39,
    width: 11.02,
    height: 47.49,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 370.135
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.88,
    width: 11.02,
    height: 53.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1019999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 420.83
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 447.78,
    width: 11.02,
    height: 56.37,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 475.965
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 504.15,
    width: 11.02,
    height: 61.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2039999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 535
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 565.84,
    width: 11.02,
    height: 63.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2244444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 597.615
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 629.4,
    width: 11.02,
    height: 70.6,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 5.51,
    y: 664.6999999999999
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 0,
    width: 37.34,
    height: 21.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.69,
    y: 10.52
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.36,
    y: 0,
    width: 39.42,
    height: 21.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5066666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.07,
    y: 10.52
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.78,
    y: 0,
    width: 40.17,
    height: 21.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5066666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.86500000000001,
    y: 10.52
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.95,
    y: 0,
    width: 41.16,
    height: 21.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5066666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.53,
    y: 10.52
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.11,
    y: 0,
    width: 47.55,
    height: 21.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5066666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.88500000000002,
    y: 10.52
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.67,
    y: 0,
    width: 65.1,
    height: 21.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5066666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.21999999999997,
    y: 10.52
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.76,
    y: 0,
    width: 66.9,
    height: 21.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.21,
    y: 10.52
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.67,
    y: 0,
    width: 67.02,
    height: 21.04,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.208
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.18,
    y: 10.52
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.69,
    y: 0,
    width: 67.08,
    height: 21.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3377777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.23,
    y: 10.52
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.78,
    y: 0,
    width: 68.27,
    height: 21.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.915,
    y: 10.52
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.05,
    y: 0,
    width: 73.49,
    height: 21.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.795,
    y: 10.52
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.54,
    y: 0,
    width: 75.46,
    height: 21.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5066666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.27,
    y: 10.52
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 21.04,
    width: 57.31,
    height: 36.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.0675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 39.175
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 57.31,
    width: 57.31,
    height: 38.32,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.386666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 76.47
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 95.63,
    width: 57.31,
    height: 38.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 114.97999999999999
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 134.33,
    width: 57.31,
    height: 40.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 154.69
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 175.05,
    width: 57.31,
    height: 50.12,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.012
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 200.11
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 225.17,
    width: 57.31,
    height: 51.63,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.45375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 250.98499999999999
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 276.8,
    width: 57.31,
    height: 64.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.16375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 309.255
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 341.71,
    width: 57.31,
    height: 66.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.187142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 375.155
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 408.6,
    width: 57.31,
    height: 67.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 442.47
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 476.34,
    width: 57.31,
    height: 71.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.408461538461538
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 512.11
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 547.88,
    width: 57.31,
    height: 73.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.731
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 584.635
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.02,
    y: 621.39,
    width: 57.31,
    height: 78.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.551666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.675,
    y: 660.6949999999999
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.32,
    y: 21.04,
    width: 60.26,
    height: 74.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.043333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.44999999999999,
    y: 58.525
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.59,
    y: 21.04,
    width: 64.6,
    height: 74.97,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.766666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.89,
    y: 58.525
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.19,
    y: 21.04,
    width: 79.74,
    height: 74.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.33
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.06,
    y: 58.525
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.93,
    y: 21.04,
    width: 87.55,
    height: 74.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 316.705,
    y: 58.525
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.47,
    y: 21.04,
    width: 95.77,
    height: 74.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.815454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.355,
    y: 58.525
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.24,
    y: 21.04,
    width: 118.55,
    height: 74.97,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.495
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515.515,
    y: 58.525
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.79,
    y: 21.04,
    width: 125.21,
    height: 74.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.495
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 637.395,
    y: 58.525
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.32,
    y: 96.01,
    width: 86.26,
    height: 110.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.584444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.44999999999999,
    y: 151.14000000000001
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.32,
    y: 206.27,
    width: 86.26,
    height: 118.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.161428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.44999999999999,
    y: 265.365
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.32,
    y: 324.46,
    width: 86.26,
    height: 119.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.626000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.44999999999999,
    y: 384.33
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.32,
    y: 444.19,
    width: 86.26,
    height: 120.65,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1883333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.44999999999999,
    y: 504.515
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.32,
    y: 564.84,
    width: 86.26,
    height: 135.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.841818181818183
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.44999999999999,
    y: 632.4200000000001
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.59,
    y: 96.01,
    width: 112.92,
    height: 205.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.546666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.05,
    y: 198.775
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.51,
    y: 96.01,
    width: 199.07,
    height: 205.53,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.43857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.04499999999996,
    y: 198.775
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.57,
    y: 96.01,
    width: 233.43,
    height: 205.53,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.285,
    y: 198.775
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.59,
    y: 301.54,
    width: 545.41,
    height: 398.46,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 36.22363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.29499999999996,
    y: 500.77
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1944);
export default __webpack_public_path__ + "static/media/1944.89da8974bd9e2e6c6d766bb72f528a47.svg";
export { ForwardRef as ReactComponent };